import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Amenity {
  name: string;
  description: string;
  icon: string;
  image: string;
  alt: string;
}

export default function AmenitiesShowcase() {
  const featuredAmenities: Amenity[] = [
  {
    name: 'Cafe @ Ground Floor',
    description: 'A cosy café Single Teas located at the ground floor, perfect for tea, bites, and conversations.',
    icon: 'BuildingOffice2Icon',
    image: "/assets/images/Singleteas-1767695839400.jpg",
    alt: 'Single Teas cafe at ground floor with outdoor seating, warm lighting and customers dining'
  },
  {
    name: 'Fitness Center @ Skypool Gym',
    description: 'State-of-the-art gym with modern equipment, just 1 minute walking distance from the property',
    icon: 'HeartIcon',
    image: "/assets/images/unnamed-1782549517255.webp",
    alt: 'Modern fitness center with treadmills, weight machines, and floor-to-ceiling windows'
  },
  {
    name: 'Swimming Pool @ Skypool',
    description: 'Temperature-controlled indoor swimming pool, just 1 minute walking distance from the property',
    icon: 'BriefcaseIcon',
    image: "/assets/images/Skypool_pool-1782549736608.webp",
    alt: 'Temperature controlled indoor swimming pool with modern facilities'
  },
  {
    name: 'Concierge Service',
    description: '24/7 assistance for all your needs',
    icon: 'UserIcon',
    image: "/assets/images/Concierge-1782551542904.png",
    alt: 'Professional concierge staff member assisting guest'
  },
  {
    name: 'Housekeeping',
    description: 'Daily cleaning and maintenance services',
    icon: 'SparklesIcon',
    image: "/assets/images/IMG20251021165343-1782552189463.jpg",
    alt: 'Clean and organized apartment bedroom with fresh linens and professional housekeeping'
  },
  {
    name: 'Street Parking',
    description: 'Open Parking with 24/7 security',
    icon: 'ShieldCheckIcon',
    image: "/assets/images/car-on-street-parking-1024x694-1782550438884.jpg",
    alt: 'Modern open parking lot with 24/7 security and clearly marked spaces'
  }];


  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl lg:text-5xl font-display font-bold text-primary mb-4">
            Luxury That Works as Hard as You Do
          </h2>
          <p className="text-lg text-text-secondary">
            Premium amenities and services designed to enhance your stay and support your lifestyle
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredAmenities.map((amenity, index) =>
          <div
            key={index}
            className="group bg-card rounded-xl overflow-hidden hover:shadow-premium transition-all duration-300">

              <div className="relative h-48 overflow-hidden">
                <AppImage
                src={amenity.image}
                alt={amenity.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute inset-0 bg-gradient-to-t from-primary/70 to-transparent" />
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                    <Icon name={amenity.icon as any} size={24} className="text-accent" />
                  </div>
                </div>
              </div>
              <div className="p-6 space-y-2">
                <h3 className="text-xl font-display font-semibold text-primary">
                  {amenity.name}
                </h3>
                <p className="text-sm text-text-secondary">
                  {amenity.description}
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="mt-12 text-center">
          <a
            href="/amenities-and-services"
            className="inline-flex items-center space-x-2 px-8 py-4 bg-accent hover:bg-accent/90 text-white font-semibold rounded-lg transition-all duration-300 hover:scale-105">

            <span>Explore All Services</span>
            <Icon name="ArrowRightIcon" size={20} className="text-white" />
          </a>
        </div>
      </div>
    </section>);

}